import * as deepmerge from "deepmerge";
import {
  packageCode /*codigosTarjetas*/
} from "@/config/constants/packagesCodes";
import ofertaCajaAhorro from "@/config/constants/ofertaCajaAhorro";

const direccion =
  "Dirección: Av. Córdoba 111 Piso 31, CABA <br/> Teléfono: 0800-333-0303<br/>  CUIT: 30-50000319-3";
const habeas_data = `
  <strong>Términos y condiciones de tratamiento de datos</strong><br />
  Los datos personales aquí incluidos tienen el carácter de declaración jurada y son recogidos para ser incorporados y tratados en una base de datos, la cual se encuentra registrada en la Agencia de Acceso a la Información Pública, cuyo destinatario y titular es el Banco BBVA Argentina S.A. Cualquier falseamiento, error y/o inexactitud respecto a la información implicará la supresión de estos datos de la base de referencia y no podrán ser utilizados a futuro.<br /><br />

  El usuario presta su consentimiento expreso al BBVA, para que toda la información referente a su persona, sus actividades económicas o las operaciones que haya concertado o que concierte en el futuro (en adelante y en su conjunto "la información") pueda ser transferida y cedida, aun en forma gratuita, dentro de estrictas políticas de confidencialidad y seguridad de los datos, a sus afiliadas, subsidiarias, controlantes, controladas y/o cualquier tercero. La información podrá ser utilizada para: a) La realización de segmentaciones o perfiles del Cliente, con fines comerciales a efectos de adaptar los productos o servicios a necesidades o características específicas, así como con fines de análisis de riesgos para evaluar nuevas operaciones, en ambos supuestos conservando dichas segmentaciones o perfiles en tanto y en cuanto el interviniente mantenga relación contractual con el BBVA, pudiendo oponerse en cualquier momento a dicho tratamiento; b) El envío a través de cualquier medio, por parte del BBVA de otros terceros, de ofertas comerciales, distintos tipos de informaciones o publicidades, personalizadas o no, sobre productos o servicios propios o de terceros; c) Para cualquier otra finalidad no incompatible con las especificadas anteriormente. Cuando así lo disponga, el usuario tendrá el derecho de acceder a la información y solicitar su rectificación o supresión de la base de archivo.<br /><br />

  La Información será conservada durante el tiempo que sea necesario para cumplir con las finalidades descritas, de acuerdo con las disposiciones legales y regulatorias vigentes.<br /><br />

  El BBVA informa al usuario que sus datos personales podrán ser cedidos a las autoridades competentes cuando las leyes o regulaciones de aplicación así lo establezcan.<br /><br />

  En función del Estándar de la Organización para la Cooperación y Desarrollo Económicos (OCDE) para el Intercambio Automático de Información en Asuntos Fiscales y de las disposiciones de la Ley de cumplimiento fiscal de cuentas extranjeras (“Foreign Account Tax Compliance Act” - FATCA) de los Estados Unidos de América, el cliente autoriza al Banco a ceder información a autoridades de terceros países por operatorias desarrolladas en los mercados internacionales tales como Estados Unidos. Lo expuesto, ya sea de forma agregada o individual, según el caso.
  El titular de los datos personales tiene el derecho de acceso a los mismos en forma gratuita en intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley 25.326.<br /><br />

  La AGENCIA DE ACCESO A LA INFORMACIÓN PUBLICA, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.<br /><br />

  <strong>Sistemas de Biometría:</strong><br />
  En caso de que el BBVA defina el uso de dispositivos para la captura, lectura y/o procesamiento de datos –inclusive aquellos de carácter biométricos– en alguno de sus procesos operativos y/o de seguridad aplicables, el usuario autoriza al BBVA a compartir estos datos con terceros exclusivamente para el resguardo de la información capturada, la verificación de la identidad del titular de los datos y/o con los fines que el BBVA determine.<br/><br />

  <strong>Sistemas de información crediticia:</strong><br/>
  Ante la solicitud de cualquier producto, el BBVA puede solicitar información a las agencias de informes comerciales a fin de evaluar la situación crediticia del usuario.<br/><br />
  El usuario acepta que estará sujeto a la clasificación e inclusión en la "Central de deudores del sistema financiero", de conformidad a la normativa vigente del B.C.R.A., dado que es obligación del BBVA informar, solamente, al Banco Central de la República Argentina todos los datos que éste le requiera o que pudiera requerirle en el futuro, relacionados con sus Clientes. No será responsabilidad del BBVA la utilización de la información del usuario por parte de terceros distintos al B.C.R.A., dado que la misma no es proporcionada por el Banco.
`;

/**
 * "Parametría" de camp. oferta nómina
 */
const fechaOfertaDesde = "01/04/2025";
const fechaOfertaHasta = "31/01/2026";
/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
export default {
  analyticsName: "nominas",
  analyticsTypology: "abrir cuenta sueldo",
  analyticsType: "abrir cuenta sueldo",
  googleAnalyticsId: "UA-179147834-1",
  googleGTMId: "GTM-PH65K3Q",
  googleGTMGA4: true,
  modulo: "Acreditación de sueldo",
  isVeridasActive: true,
  cantPasos: 5,
  pasos: {
    consulta: {
      path: "/",
      component: "views/ConsultaWrapper",
      titulo:
        "Tu cuenta sueldo, con todo lo necesario para que tu plata rinda más",
      subtitulo:
        "Disfrutá de reintegros, ahorros en supermercados, combustible y mucho más desde el primer día",
      footerText: direccion + "<br /><br />" + habeas_data,
      analyticsName: "home",
      recaptcha:
        "Este sitio web está protegido por reCAPTCHA y se aplica la <a href='https://www.google.com/intl/es/policies/privacy/' style='color: #1464A5; font-weight: 600; text-decoration: none;'>Política de Privacidad</a> y los <a href='https://www.google.com/intl/es/policies/terms/' style='color: #1464A5; font-weight: 600; text-decoration: none;'>Términos de Servicio</a> de Google.",
      footerTheme: "light"
    },
    oferta: {
      path: "/oferta",
      component: "views/Oferta",
      pasoSiguiente: "paso1",
      pasoAnterior: "consulta",
      analyticsName: "oferta",
      tituloTimeline: {
        cliente: "¿Cómo abro mi cuenta sueldo?",
        noCliente: "¿Cómo hago para tener mi cuenta sueldo en BBVA?"
      },
      steps: {
        cliente: [
          "Entrá a Banca Online y buscá tu CBU",
          "Enviá tu CBU a tu empresa y pedí que acrediten tu sueldo en BBVA.",
          "Recibí tus haberes en tu caja de ahorro."
        ],
        noCliente: [
          "Abrí tu cuenta en BBVA",
          "Entrá a Banca Online y buscá tu CBU",
          "Enviá tu CBU a tu empresa y pedí que acrediten tu sueldo en BBVA.",
          "Recibí tus haberes en tu caja de ahorro"
        ]
      },
      disclaimerTimeline: {
        title:
          "Tenés hasta 60 días para completar estos pasos. Si cumplís los requisitos vas a recibir tu premio de bienvenida y tener tu cuenta 100% bonificada.",
        subtitle:
          "Pasado ese tiempo, si tu empleador no acredita tus haberes en tu cuenta sueldo BBVA, no recibirás premio de bienvenida."
      },
      banners: {
        bannerDespegar: {
          title: "¡Viajá con tus consumos!",
          subtitle:
            "Tus compras con tarjeta de crédito sumán Millas BBVA. Canjealos por vuelos, alojamientos y experiencias en destinos increíbles."
        },

        bannerDespegar2: {
          title: "¡Viajá con tus consumos!",
          subtitle: "Tus compras con tarjeta de crédito sumán Millas BBVA.",
          subtitle2:
            "Canjealos por vuelos, alojamientos y experiencias en destinos increíbles."
        },

        bannerMODO: {
          title:
            "Hasta un 40% de descuento en farmacias, belleza, entretenimiento y mucho más",
          subtitle:
            "Aprovechá descuentos y reintegros todos los días con MODO y tus tarjetas BBVA"
        },
        bannerMasComodo: {
          title: "Todo es más cómodo con BBVA",
          subtitle: [
            "Tus finanzas a mano y seguras con la app BBVA y Banca Online.",
            "Compras online con tu tarjeta.",
            "Pagos con QR desde tu celular.",
            "Efectivo disponible en cajeros Banelco y en supermercados adheridos."
          ]
        },

        bannerFinanzas: {
          title:
            "Podés pagar en cuotas y organizar tus finanzas como más te convenga",
          subtitle: "Seguí tus movimientos en la app BBVA y Banca Online"
        },

        bannerBienvenida: {
          title: "Tenemos un regalo de bienvenida para vos"
        }
      }
    },
    renaperConfirmar: {
      path: "/confirmar-datos",
      titulo: "Confirmá los datos",
      subtitulo:
        "Corroborá que estén correctos, de no ser así podés modificarlos.",
      component: "views/RenaperConfirmar",
      pasoSiguiente: "renaperConsultar",
      nombreSiguiente: "Confirmar",
      pasoAnterior: "consulta"
    },
    renaperConsultar: {
      path: "/confirmar-datos-renaper",
      titulo: "Por último, completá el número de trámite que figura en tu DNI",
      subtitulo:
        "Vamos a hacer una consulta al Registro Nacional de las Personas (RENAPER) para validar los datos.",
      component: "views/RenaperConsultar",
      pasoAnterior: "renaperConfirmar"
    },
    ofertaCA: {
      path: "/ofertaCA",
      component: "views/OfertaCA",
      titulo: "Caja de ahorro + Visa Débito",
      subtitulo: "Cobrá tu sueldo en BBVA y disfrutá de:",
      botonSiguiente: "Continuar",
      pasoSiguiente: "sucursal",
      footerText: ofertaCajaAhorro().legales,
      pasoAnterior: "consulta"
    },
    ofertaCuenta: {
      path: "/ofertaCuenta",
      component: "views/OfertaCuenta",
      titulo: "Caja de ahorro + Visa Débito",
      subtitulo: "Tené tu cuenta en BBVA y disfrutá de:",
      botonSiguiente: "Abrí tu cuenta en BBVA",
      pasoSiguiente: "datosPersonales",
      footerText: ofertaCajaAhorro().legales,
      analyticsName: "oferta"
    },
    sucursal: {
      path: "/sucursal",
      component: "views/Sucursal",
      pasoSiguiente: "graciasCA",
      pasoAnterior: "ofertaCA",
      titulo: "Elegí tu sucursal",
      subtitulo:
        "Te pedimos que elijas una sucursal donde vamos a abrir tu cuenta, <strong> pero recordá que podés acercarte a firmar el contrato a la sucursal que te resulte más cómoda.</strong> <br /><br />Una vez que firmes el contrato vamos a enviarte la tarjeta de débito al domicilio que indiques en la sucursal. Cualquier persona mayor de 14 años podrá recibirla.",
      nombreSiguiente: "Finalizar",
      remarketing: {
        titulo: "Te pedimos unos últimos datos para abrir tu cuenta",
        subtitulo:
          "<strong>Elegí tu sucursal</strong><br>Elegí la sucursal donde va a estar radicada tu cuenta",
        nombreSiguiente: "Confirmar"
      }
    },
    paso1: {
      path: "/paso1",
      component: "views/Paso1",
      pasoSiguiente: "paso2",
      paso: 1,
      pasoAnterior: "oferta",
      titulo: "Datos personales",
      subtitulo: "Te pedimos estos datos para comenzar el proceso",
      analyticsName: "datos personales"
    },
    paso2: {
      path: "/paso2",
      component: "views/Paso2",
      pasoSiguiente: "paso3",
      paso: 2,
      pasoAnterior: "paso1",
      titulo: "Datos laborales",
      subtitulo: "Queremos conocer más acerca de tu trabajo",
      analyticsName: "datos laborales"
    },
    paso3: {
      path: "/paso3",
      component: "views/Paso3",
      pasoSiguiente: "paso4",
      paso: 3,
      pasoAnterior: "paso2",
      titulo: "Información adicional",
      subtitulo:
        "Si nunca escuchaste hablar de estos términos seguramente tus respuestas deberían ser 'No'.",
      analyticsName: "actividad"
    },
    paso4: {
      path: "/paso4",
      component: "views/Paso4",
      pasoSiguiente: "gracias",
      nombreSiguiente: "Finalizar",
      paso: 4,
      pasoAnterior: "paso3",
      titulo: "Coordiná la entrega de tus tarjetas",
      analyticsName: "firma",
      subtitulo:
        "Nuestro servicio de mensajería, se pondrá en contacto con vos para informarte el día de entrega de tus productos. <br /> <br /><strong>Te pedimos que seas vos quién reciba las tarjetas y tengas a mano tu DNI para que el/la representante del correo le saque una foto del frente y dorso.</strong> Esto es una medida de seguridad para validar tu identidad."
    },
    datosPersonales: {
      path: "/datosPersonales",
      component: "views/DatosPersonales",
      askLeave: true,
      pasoSiguiente: "datosLaborales",
      pasoAnterior: "ofertaCuenta",
      paso: 1,
      antetitulo: null,
      titulo: "Datos personales",
      subtitulo: "Te pedimos estos datos para comenzar el proceso",
      analyticsName: "datos personales"
    },
    datosLaborales: {
      path: "/datosLaborales",
      component: "views/DatosLaborales",
      askLeave: true,
      pasoSiguiente: "informacionAdicional",
      pasoAnterior: "datosPersonales",
      paso: 2,
      antetitulo: null,
      titulo: "Datos laborales",
      subtitulo:
        "Quedate tranquilo, los datos que ingreses en este paso no van a modificar la oferta que te hicimos.",
      analyticsName: "datos laborales"
    },
    informacionAdicional: {
      path: "/informacionAdicional",
      component: "views/InformacionAdicional",
      paso: 3,
      askLeave: true,
      pasoSiguiente: "identidad",
      pasoAnterior: "datosLaborales",
      nombreSiguiente: "Continuar",
      titulo: "Información adicional",
      subtitulo:
        'Si nunca escuchaste hablar de estos términos seguramente tus respuestas deberían ser "No”.',
      analyticsName: "informacionAdicional"
    },
    identidad: {
      path: "/identidad",
      component: "views/Identidad",
      paso: 4,
      askLeave: true,
      pasoSiguiente: "loadingVeridas",
      pasoAnterior: "informacionAdicional",
      titulo: "Validá tu identidad",
      subtitulo: "Vamos a pedirte unas fotos de tu DNI y unas selfies",
      analyticsName: "identidad"
    },
    loadingVeridas: {
      path: "/verificando-biometria",
      component: "views/LoadingVeridas",
      pasoSiguiente: "biometriaOK",
      askLeave: true,
      analyticsName: "verificando biometria"
    },
    biometriaOK: {
      path: "/biometria-ok",
      component: "views/OkVeridas",
      pasoSiguiente: "configuracion",
      askLeave: true,
      analyticsName: "biometria-ok"
    },
    configuracion: {
      path: "/configuracion",
      component: "views/Configuracion",
      askLeave: true,
      pasoSiguiente: "contrato",
      pasoAnterior: "biometriaOK",
      paso: 7,
      antetitulo: null,
      titulo: "Coordiná la entrega de tus tarjetas",
      subtitulo:
        "Como validaste tu identidad <strong>de forma online, cualquier persona mayor de 14 años</strong> va a poder recibir las tarjetas.",
      analyticsName: "configuracion"
    },
    contrato: {
      path: "/contrato",
      component: "views/Contrato",
      askLeave: true,
      pasoSiguiente: "thank",
      pasoAnterior: "configuracion",
      nombreSiguiente: "Finalizar",
      paso: 8,
      antetitulo: null,
      titulo: "Por último, leé y aceptá el contrato digital",
      subtitulo: null,
      analyticsName: "contrato"
    },
    thank: {
      path: "/graciasCajaAhorro",
      pasoSiguiente: "celular",
      component: "views/GraciasCajaAhorro",
      subtitulo:
        "Te enviaremos tu tarjeta de débito, dentro de los próximos 10 días hábiles a ",
      creado: [
        "Creá tu Usuario y Clave y validá tu celular para operar en Banca Online",
        "Validá tu celular para operar en Banca Online"
      ],
      ingresa:
        "Desde Banca Online podés gestionar tus operaciones de manera ágil.",
      link: [
        "Crear mi Usuario y Clave<br>y validar mi celular",
        "Validar mi celular"
      ],
      // incluye: "¿Qué incluye tu cuenta?",
      // item1: "Caja de ahorro en pesos",
      // item2: "Esta va a ser tu cuenta sueldo.",
      item3:
        "Recordá que tu caja de ahorro estará vinculada a tu Tarjeta Visa débito existente."
    },
    gracias: {
      path: "/gracias",
      pasoAnterior: "paso4",
      component: "views/Gracias",
      footerText: null,
      analyticsName: "gracias"
    },
    graciasCA: {
      path: "/graciasCA",
      pasoAnterior: "sucursal",
      component: "views/GraciasCA",
      nombreSiguiente: "Finalizar"
    },
    mensaje: {
      path: "/mensaje/:mje",
      component: "views/Mensaje"
    },
    cliente: {
      path: "/cliente",
      component: "views/Cliente",
      pasoAnterior: "consulta",
      footerText: `Vigencia y condiciones. Cartera de consumo. Oferta válida del <span data-obfuscate>${fechaOfertaDesde}</span> a <span data-obfuscate>${fechaOfertaHasta}</span> exclusiva
      para personas que comiencen a acreditar haberes a través de BBVA dentro del período de vigencia indicado, exclusiva
      para empleados en relación de dependencia y que hayan pasado más de 12 meses desde su última acreditación de haberes 
      en BBVA. El cambio de empresa empleadora no es condicionante para realizar el pago del regalo de bienvenida.
      Bonificaciones. Las bonificaciones correspondientes a las comisiones por mantenimiento mensual de la paquete Express, paquete Gold, paquete Platinum o paquete Black estarán vigentes siempre que se mantenga la acreditación de haberes en el banco.
      En caso se cesar la acreditación se cobrarán las comisiones y cargos correspondientes al momento del cese.
      Consulte comisiones vigentes en www.bbva.com. La apertura de la Cuenta está sujeta a aprobación crediticia del departamento
      de créditos del Banco BBVA Argentina S.A.`
    },
    confirmar: {
      path: "/confirmar",
      nombreSiguiente: "Confirmar",
      pasoSiguiente: "gracias",
      component: "views/Confirmar",
      titulo: "Confirmá tus datos de contacto",
      paso: 1,
      subtitulo:
        "Corroborá que tu <strong> e-mail y celular sean correctos</strong>, vamos a comunicarnos con vos a través de éstos para que puedas cobrar tu sueldo en BBVA."
    },
    noCliente: {
      path: "/noCliente",
      component: "views/NoCliente",
      pasoAnterior: "consulta"
    },
    clienteCA: {
      path: "/clienteCA",
      component: "views/ClienteCA",
      titulo: "Obtené tu CBU y cobrá tu sueldo en BBVA",
      descripcion:
        "Te pedimos que ingreses a Banca Online con tu usuario y clave digital para obtener tu CBU y compartírselo a tu empleador.",
      beneficiosTitulo: "Y te damos estos beneficios:",
      beneficios: [
        {
          label:
            "El mantenimiento de tu cuenta será <strong data-obfuscate>100% bonificado</strong>",
          description: "Mientras acredites tu sueldo en BBVA"
        },
        {
          label: "Tasa exclusiva para préstamos personales",
          description:
            "Para que puedas remodelar tu casa o cambiar tu auto. (*)"
        }
      ],
      footerText: `Cartera de consumo. Vigencia <span data-obfuscate>${fechaOfertaDesde}</span> a <span data-obfuscate>${fechaOfertaHasta}</span>. <br/> (*) Para más información consulta en <a href="https://www.bbva.com.ar/personas/productos/prestamos/personales/pesos.html">https://www.bbva.com.ar/personas/productos/prestamos/personales/pesos.html</a> <br/> 
      <strong> Bonificaciones </strong> Las bonificaciones correspondientes a las comisiones por mantenimiento mensual estarán vigentes siempre que se mantenga la acreditación de haberes en el banco. En caso de cesar la acreditación se cobrarán las comisiones y cargos correspondientes al momento del cese. <br/> <br/>
      <strong> Aviso legal </strong> <br/> Cartera de consumo. Los accionistas de Banco BBVA Argentina, S.A. limitan su responsabilidad a la integración de las acciones suscriptas. Ley Nº 19.550 y Ley Nº 25.738. CUIT 30-50000319-3. Av. Córdoba 111 Piso 31, Ciudad Autónoma de Buenos Aires. Código postal C1054AAA.`
    },
    continuaSucursal: {
      path: "/error-confirmacion/:mensaje?",
      component: "views/ContinuaSucursal",
      footerText: null
    },
    mensajeVeridas: {
      path: "/error-veridas/:mje",
      component: "views/MensajeVeridas"
    },
    celular: {
      path: "/celular",
      component: "views/Celular",
      askLeave: true,
      pasoSiguiente: "usuarioClave",
      pasoAnterior: "thank",
      antetitulo: null,
      subtitulo:
        "Escribí tu número para que te enviemos un código de verificación por SMS.",
      titulo: "Validá tu celular",
      analyticsName: "celular"
    },
    usuarioClave: {
      path: "/usuario-y-clave",
      component: "views/UsuarioClave",
      askLeave: true,
      pasoSiguiente: "thankOTP",
      pasoAnterior: "celular",
      antetitulo: null,
      titulo: "Creá tu usuario y clave digital",
      subtitulo:
        "Elegí el nombre de usuario y la clave digital que vas a utilizar para acceder a la banca online. <strong>Recordá no usar datos filiatorios ni de fácil deducción.</strong>",
      analyticsName: "usuario y clave"
    },
    thankOTP: {
      path: "/gracias-otp",
      component: "views/ThankYouOtp",
      footerText: null
    },
    mensajeErrorSolicitudCuenta: {
      path: "/mensajeSolicitudCuenta/:mje",
      component: "views/MensajeErrorSolicitudCuenta",
      header: "Solicitud de Cuenta",
      titulo: "Esta oferta no está disponible",
      texto:
        "Ingresá a Banca Online y conocé los productos a los que podés acceder."
    }
  }
};

/**
 * Configuración de info de paquete para campaña
 */
export const infoCampania = (paquete /**, beneficiosGlobales */) => {
  // Info de campaña general
  let infoCampania = {};

  /**
   * Configuración específica para cada paquete
   * La configuración anterior es válida para la campaña actual y TODOS los paquetes
   * En el siguiente puedo sobreescribir configuración específica para cada paquete
   */
  let _paqueteEspeciales = {
    /*Dejar vacío*/
  };
  switch (paquete.tipoPaquete) {
    case packageCode.TARJETA_SUELTA:
    case packageCode.LIBRETON_EXPRESS:
    case packageCode.LIBRETON_FULL:
    case packageCode.LIBRETON_PLUS_GOLD:
    case packageCode.LIBRETON_PREMIUM:
    case packageCode.LIBRETON_PREMIUM_WORLD:
      _paqueteEspeciales = {};
      break;
  }

  /**
   * Configuración específica para cada paquete POR TARJETA (SOLO VALIDO PARA TARJETA SUELTA)
   * La configuración anterior es válida para la campaña actual y TODOS los paquetes
   * En el siguiente puedo sobreescribir configuración específica para cada tarjeta de tarjeta suelta
   * VER EJEMPLOS EN ofertaPeugeot
   */
  let _paqueteEspecialesPorTarjeta = {
    /*Dejar vacío*/
  };

  /**
   * Sobreescribir algunos campos que dependen de la configuración global
   * CUIDADO: No sobreescribir campos de beneficiosGlobales directamente
   * VER EJEMPLO DE USO EN ofertaPeugeot
   */
  let _globalesOverwrite = {
    /* Dejar vacío*/
  };

  // Devolver el objeto mergeado
  const overwriteMerge = (_, sourceArray) => sourceArray;
  return deepmerge.all(
    [
      infoCampania,
      _paqueteEspeciales,
      _paqueteEspecialesPorTarjeta,
      _globalesOverwrite
    ],
    { arrayMerge: overwriteMerge }
  );
};

/**
 * Configuración de los nombres de tarjeta
 * (no necesaria, debe exportarse vacía)
 */
export const nombresTarjetas = {};

/**
 * Configuración de los nombres de tarjeta para Adobe Tagging
 * (no necesaria, debe exportarse vacía)
 */
export const nombresTarjetasAdobe = {};

export const premios = [
  {
    label: "Cajeros BBVA <br/>las 24 horas",
    icon: "bbva-branch.png"
  },
  {
    label: "Préstamos con tasa exclusiva (*)",
    icon: "loan-dollar.png"
  },
  {
    label: "Banca Online <br/>y BBVA móvil",
    icon: "devices.png"
  }
];

export const beneficios = [
  {
    label: "Cargá el saldo de tu <strong>SUBE o celular</strong>",
    description: "Todas las veces que quieras desde Banca Online."
  },
  {
    label: "Obtené tu <strong>Tarjeta Recargable</strong>",
    description:
      "Podés cargarle crédito y pagar servicios de streaming, música y más!"
  },
  {
    label:
      "Depositá y extraé dinero en cajeros automáticos <strong>BBVA</strong> las 24 horas",
    description: ""
  },
  {
    label:
      "Invertí en un <strong>Plazo Fijo</strong> y hacé crecer tus ahorros",
    description:
      "Desde Banca Online podés constituir plazos fijos tradicionales en pesos."
  },
  {
    label:
      "Accedé a <strong>Banca Online</strong> y <strong>BBVA Móvil</strong>",
    description: "Transferí, consultá y operá desde tu computadora o celular."
  },
  {
    label: "Adherí tus pagos e impuestos al débito automático",
    description: "Y olvidate de hacer largas filas."
  }
];

export const oferta = [
  "<strong>Caja de ahorro en pesos </strong><br> Esta va a ser tu cuenta sueldo.<br>",
  "<strong>Tarjeta Visa Débito</strong>"
];

export const proximosPasos = [
  {
    label:
      "Acercate a la sucursal que elegiste para firmar el contrato de tu cuenta. En la sucursal además te pediremos un domicilio para enviarte por correo la tarjeta de débito. No hace falta que la recibas vos, ya que cualquier persona mayor de 14 años podrá hacerlo."
  },
  {
    cbu: true,
    label:
      "<strong>Acreditá tu sueldo en BBVA.</strong> Informale a tu empleador este número de CBU correspondiente a tu nueva cuenta sueldo. <strong>Tené en cuenta que para empezar a usar tu nueva cuenta sueldo deberás recibir primero tu tarjeta de débito.</strong>"
  },
  {
    label:
      "<strong>Ingresá a banca online.</strong> Cuando recibas tu tarjeta de débito, ingresá a banca online y creá tu Usuario y Clave digital.",
    modal: "Cómo obtener mi Usuario y Clave Digital"
  }
];
